

























import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { modalReceiptHistoryStore } from '@/store'
import { DataTable, Col } from '@/components/molecules/DataTable'
import { ReceiptPrintHistory } from '@/types'
import ReceiptHistoryService from '@/services/ReceiptHistoryService'

@Component({
  components: {
    ModalFooter,
    DataTable
  }
})
export default class ModalReceiptHistory extends ModalComponentBaseVue {
  get cols(): Col[] {
    return [
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '30',
        items: [
          {
            name: 'receiptPrintName',
            headerText: 'タイトル'
          }
        ]
      },
      {
        width: '32',
        items: [
          {
            name: 'subject',
            headerText: '内容'
          }
        ]
      },
      {
        width: '28',
        items: [
          {
            name: 'dateTime',
            headerText: '印刷日時'
          }
        ]
      },
      {
        width: '10',
        items: [
          {
            name: 'action',
            headerText: '',
            align: 'center'
          }
        ]
      }
    ]
  }

  items: ReceiptPrintHistory[] = []

  tableBodyHeight: number = 400

  get isOpen(): boolean {
    return modalReceiptHistoryStore.isOpen
  }

  @Watch('isOpen')
  changeOpen(): void {
    if (this.isOpen) {
      this.init()
    }
  }

  init() {
    this.items = new ReceiptHistoryService().load()
  }

  onClickPrint(item: ReceiptPrintHistory): void {
    this.$webSocket.sendReceiptPrintMessage({
      command: item.commandType,
      name: undefined,
      data: item.data,
      subject: undefined,
      maxPrintCount: item.maxPrintCount,
      customerCode: item.customerCode
    })
  }

  onClickCancel(): void {
    modalReceiptHistoryStore.cancel()
  }
}
